<template>
    <div class="header">
        <div class="pc-header">
            <div class="header-logo cup" @click="toIndexFn">
                <span>
                    <img src="http://music.chinaman.cn/mybigdatas/icm2030/new0616/logo.png" alt="">
                </span>
                <p>ICM 2030 Hong Kong</p>
            </div>
            <div class="header-lists">
                <div class="list" @click="toPageFn(item.path, 'null')" :class="active == item.path ? 'active' : ''"
                    v-for="item in routerList" :key="item.name">
                    <div class="header-title"> {{ item.name }}</div>
                    <div class="header-children" style="display:none">
                        <div class="children-lists">
                            <p v-for="(child, i) in item.children" :key="child.id" @click.stop="toPageFn(item.path, i)">
                                {{ child.name }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="navbar-collapse" id="navbarNav">
            <div class="top-header">
                <p @click="toIndexFn">ICM 2030 Hong Kong</p>
                <i class="el-icon-menu icon" @click.stop="showMenu = true"></i>
            </div>
            <div class="h5-bg" v-if="showMenu">
                <ul class="h5-nav">
                    <p class="h5-title">
                        <span>Menu</span>
                        <i class="el-icon-close" @click="showMenu = false"></i>
                    </p>
                    <li class="h5-item" v-for="(item, index) in routerList" :class="active == item.path ? 'active' : ''"
                        @click="toPageFn(item.path, 'null')">
                        <p class="h5-item-title">
                            {{ item.name }}
                        </p>
                        <template style="display:none" v-if="item.children && item.children.length > 0">
                            <ul class="h5-item-children">
                                <li v-for="(itm, i) in item.children" class="h5-item-children-item"
                                    @click.stop="toPageFn(item.path, i)">
                                    <p class="h5-item-children-item-title">
                                        {{ itm.name }}
                                    </p>
                                </li>
                            </ul>
                        </template>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>


export default {
    data() {
        return {
            showMenu: false,
            active: '/',
            routerList: [{
                name: 'Home',
                path: '/',
                children: [{
                    name: 'HK at a Glance',
                    id: 'glance'
                }, {
                    name: "Chairman's Speech",
                    id: 'chairman'
                }, {
                    name: 'News',
                    id: 'news'
                }, {
                    name: 'Globally Endorsed',
                    id: 'worldwide'
                }]
            },
            {
                name: 'Congress',
                path: '/gaIcm',
                children: [{
                    name: 'The Timeline',
                    id: 'timeline'
                }, {
                    name: "The Venue",
                    id: 'venue'
                }, {
                    name: 'Satellite Conferences',
                    id: 'satellite'
                }, {
                    name: 'Conference Proceedings',
                    id: 'proceeding'
                },
                {
                    name: 'Outreach Programme',
                    id: 'outreach'
                }]
            },
            {
                name: 'Support',
                path: '/comprehensiveSupport',
                children: [{
                    name: 'For All Mathematicians',
                    id: 'mathematicians1',
                }, {
                    name: 'Early-career support ',
                    id: 'support',
                }, {
                    name: 'GA Support',
                    id: 'ga',
                }, {
                    name: 'Young Scholars Program',
                    id: 'programme',
                }, {
                    name: 'Other support',
                    id: 'other',
                }]
            },
            {
                name: 'Hong Kong',
                path: '/why',
                children: [{
                    name: 'Mathematics Hub',
                    id: 'mathematics'
                }, {
                    name: 'Mathematics Heritage',
                    id: 'history'
                }, {
                    name: 'Safety & Connectivity',
                    id: 'safety'
                }, {
                    name: 'Delegate Benefits',
                    id: 'city',
                }, {
                    name: 'Experience HK',
                    id: 'experience HK'
                }]
            },
            {
                name: 'Organisers',
                path: '/organizers',
                children: [{
                    name: 'HK Math Society',
                    id: 'mathematical'
                }, {
                    name: 'Organizing Committee',
                    id: 'organizing'
                }, {
                    name: 'Past Experience',
                    id: 'past'
                }, {
                    name: 'Partners and Endorsers',
                    id: 'universities'
                }]
            },
                //  {
                //     name: 'Resource',
                //     path: '/resource',
                //     children: [{
                //         name: 'Download',
                //         id: 'down'
                //     }, {
                //         name: 'video',
                //         id: 'video'
                //     }, {
                //         name: 'News',
                //         id: 'news'
                //     }]
                // },
                // {
                //     name: 'Media Centre',
                //     path: '/mediaCentre',
                //     children: [{
                //         name: 'Download',
                //         id: 'down'
                //     }, {
                //         name: 'video',
                //         id: 'video'
                //     }, {
                //         name: 'News',
                //         id: 'news'
                //     }]
                // },
                // {
                //     name: 'Contact Us',
                //     path: '/contactUs',
                //     children: [{
                //         name: 'FAQ',
                //         id: 'faq'
                //     }, {
                //         name: 'Inquiries',
                //         id: 'support'
                //     }]
                // },
            ]
        }
    },
    components: {
    },
    mounted() {
        this.active = this.$route.path
        if (this.active == '/wait') {
            this.active = null
        }
    },
    watch: {
        $route(to) {
            this.active = to.path
            if (this.active == '/wait') {
                this.active = null
            }
        }
    },
    methods: {
        toIndexFn() {
            this.$router.push('/')
        },
        toPageFn(url, i) {
            this.$router.push(url)
            console.log(url, '----')
            this.showMenu = false
            // if (i != 'null') {
            //     this.$router.push(url + '?currentNav=' + Number(i + 1))
            //     this.showMenu = false
            // } else {
            //     this.$router.push(url)
            //     this.showMenu = false
            // }
        }
    }
}
</script>

<style lang="less" scoped>
.header {
    height: 70px;
    padding: 0 20px;
    position: fixed;
    top: 0;
    width: 100%;
    left: 0;
    z-index: 999;
    background: #fff;
    border-bottom: 1px solid #F8FAFC;

    .pc-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 100%;
        max-width: 1200px;
        margin: 0 auto;
    }

    .header-logo {
        display: flex;
        align-items: center;

        span {
            width: 40px;
            height: 40px;
            margin-right: 10px;
            display: inline-block;
        }

        img {
            width: 40px;
            height: 40px;
            display: inline-block;
        }
    }

    .header-lists {
        display: flex;
    }

    .list {
        font-size: 16px;
        margin: 0 20px;
        color: #100f0d;
        transition: 0.3s all;
        position: relative;

        .header-title {
            cursor: pointer;
            height: 100%;
            display: flex;
            align-items: center;
        }
    }

    .list.active {
        color: #0065FF;
        position: relative;
        font-weight: bold;

        &::after {
            content: '';
            position: absolute;
            bottom: -5px;
            left: 50%;
            transform: translateX(-50%);
            width: 30px;
            height: 2px;
            background: #0065FF;
        }
    }

    .header-children {
        display: none;
        position: absolute;
        top: 100%;
        margin-top: -10px;
        left: 50%;
        transform: translateX(-50%);
        border-radius: 4px;
        padding: 30px 0;
        z-index: 9999;
        min-width: 200px;
        max-width: 300px;

        .children-lists {
            border-radius: 10px;
            background: #fff;
            border-top: 1px solid #eee;
            box-shadow: 0 2px 6px #0065FFbe;
            padding: 10px 0;
        }

        p {
            color: #100f0d;
            font-size: 16px;
            font-weight: 400;
            height: 35px;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: 0.3s all;
            border-bottom: 1px dashed #eee;
        }

        p:nth-last-of-type(1) {
            border-bottom: none;
        }

        p:hover {
            color: #0065FF;
            cursor: pointer;
            background-color: #0065FF19;
        }

        .list:hover .header-children {
            display: block;
        }
    }

    .list:hover {
        color: #0065FF;
        cursor: pointer;

        .header-children {
            display: block;
        }
    }
}

@media screen and (min-width: 1650px) and (max-width: 1919px) {
    .header {
        transform: scale(1.1);
        transform-origin: center top;
    }
}

/* 1920px ~ 2299px */
@media screen and (min-width: 1920px) and (max-width: 2299px) {
    .header {
        transform: scale(1.2);
        transform-origin: center top;
    }
}

/* ≥2300px 超大屏 */
@media screen and (min-width: 2300) and (max-width: 3000) {
    .header {
        transform: scale(1.3);
        transform-origin: center top;
    }
}


/* ≥2300px 超大屏 */
@media screen and (min-width: 3001) and (max-width: 3999) {
    .header {
        transform: scale(1.4);
        transform-origin: center top;
    }
}

// 大于3000
@media screen and (min-width: 3000px) {
    .header {
        transform: scale(1.5);
        transform-origin: center top;
    }
}

// Mobile & Tablet Responsive Styles
@media screen and (max-width: 1024px) {
    .header {
        padding: 0 15px;
        // overflow-x: auto;
        justify-content: flex-start;
        -webkit-overflow-scrolling: touch;

        .list {
            margin: 0 15px;
            font-size: 14px;
            flex-shrink: 0;
        }
    }

}

.navbar-collapse {
    display: none;
}

.pc-header {
    display: flex;
}

.top-header {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 70px;
    z-index: 9999;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    box-sizing: border-box;
    background: #fff;

    i {
        font-size: 20px;
    }

    p {
        color: #0065FF;
        font-size: 18px;
    }
}

.h5-bg {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    display: block;
    background-color: #141313b6;
    z-index: 999999;
}

.h5-nav {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    width: 80%;
    max-width: 300px;
    background-color: #fff;
    height: 100vh;
    overflow-y: auto;

    .h5-title {
        height: 50px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 15px;
        box-sizing: border-box;
        border-bottom: 1px solid #ececec;

    }

    .h5-item-title {
        height: 45px;
        border-bottom: 1px solid #ececec;
        font-size: 14px;
        padding: 0 15px;
        box-sizing: border-box;
        line-height: 45px;
        font-size: 17px;
        color: #333;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .h5-item-children {
        display: none;
    }

    .h5-item.active .h5-item-children {
        display: block;
        display: none;
        font-size: 14px;
        padding: 5px 0;
        color: #444;
        background-color: #f0f7fc;
        border-bottom: 1px solid #d1ebfd;
        border-top: 1px solid #d1ebfd;
    }

    .h5-item-children-item-title {
        padding-left: 25px;
        line-height: 35px;
        border-bottom: 1px solid #e0e0e0;
    }

    .h5-item-children-item-title:last-child {
        border-bottom: none;
    }

    .active .el-icon-arrow-right {
        transform: rotateZ(90deg);
        transition: transform 0.3s ease;
    }
}

@media screen and (max-width: 768px) {
    .navbar-collapse {
        display: block;
    }

    .pc-header {
        display: none;
        overflow: hidden;
    }

    .top-header {
        height: 60px;
    }

    .header {
        height: 60px;
        padding: 0 10px;

        .list {
            margin: 0 10px;
            font-size: 13px;

            .header-title {
                height: 60px;
            }
        }

        .list.active {
            &::after {
                bottom: -3px;
                width: 20px;
            }
        }

        .header-children {
            min-width: 160px;
            padding: 15px 0;

            p {
                font-size: 14px;
                height: 32px;
            }
        }
    }
}


@media screen and (max-width: 480px) {
    .navbar-collapse {
        display: block;
    }

    .pc-header {
        display: none;
    }

    .top-header {
        height: 50px;
        padding: 0 15px;

        p {
            font-size: 16px;
        }

        i {
            font-size: 18px;
        }
    }

    .header {
        height: 50px;

        .list {
            margin: 0 8px;
            font-size: 12px;

            .header-title {
                height: 50px;
            }
        }
    }

    .h5-nav {
        width: 90%;
        max-width: 280px;
    }

    .h5-title {
        padding: 0 10px;
    }

    .h5-item-title {
        font-size: 15px;
        padding: 0 10px;
    }

    .h5-item-children-item-title {
        padding-left: 20px;
        font-size: 13px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/header.vue